import React from 'react';

import {translations} from 'presentation/translations-new';

import {AlertModal} from '../AlertModal';
import {useEmergencyTelehealthUnavailableRoomModalStore} from './store';

const {headerTitle, title, description, buttonLabel} =
	translations['pt-br'].privateFlow.emergencyTelehealthJourney.unavailableRoomModal;

export function EmergencyTelehealthUnavailableRoomModal() {
	const isOpen = useEmergencyTelehealthUnavailableRoomModalStore(state => state.isOpen);
	const onClose = useEmergencyTelehealthUnavailableRoomModalStore(state => state.onClose);

	return (
		<AlertModal
			open={isOpen}
			onClose={onClose}
			headerTitle={headerTitle}
			title={title}
			description={description}
			buttonLabel={buttonLabel}
			variant="info"
			disableClose
		/>
	);
}
